module.exports = __webpack_public_path__ + "img/search.fd72abb3.svg";